import axiosClient from "utils/api/axios-client";

const configApi = {
  getConfig: () => {
    const url = "/api/v1/food/config";
    return axiosClient.get(url);
  },

  update: (config) => {
    const url = `/api/v1/food/config`;
    return axiosClient.put(url, config);
  },

  getSearchLog: (params) => {
    const url = "/api/v1/search-logs";
    return axiosClient.get(url, { params });
  },

  // Search Suggestions APIs
  getSearchSuggestions: (params) => {
    const url = "/api/v1/search-suggestions";
    return axiosClient.get(url, { params });
  },

  createSearchSuggestion: (data) => {
    const url = "/api/v1/search-suggestions";
    return axiosClient.post(url, data);
  },

  updateSearchSuggestion: (id, data) => {
    const url = `/api/v1/search-suggestions/${id}`;
    return axiosClient.put(url, data);
  },

  deleteSearchSuggestion: (id) => {
    const url = `/api/v1/search-suggestions/${id}`;
    return axiosClient.delete(url);
  },
};

export default configApi;
